
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1px7g_15do8_93",
  "chart-filter": "awsui_chart-filter_1px7g_15do8_106",
  "custom-icon-wrapper": "awsui_custom-icon-wrapper_1px7g_15do8_110"
};
  